import { useCallback, useEffect, useState } from 'react';
import { shareApi } from '../services/shareApi';
import { SHARE_USE_STUB as USE_STUB } from '../config';
import { SHARED_COURSE_STUB } from '../fixtures/shareStub';

// Loads the public preview for a share token. Used by the /shared/:token page.
export function useSharedCourse(token) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!token) {
      setError('This shared course link is missing its code.');
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      if (USE_STUB) {
        // Brief delay so the loading state actually renders.
        await new Promise((r) => setTimeout(r, 140));
        setData({ ...SHARED_COURSE_STUB, token });
      } else {
        const res = await shareApi.getShare({ token });
        setData(res);
      }
    } catch (e) {
      // Public route (anonymous, unauthenticated visitors) — never surface
      // raw backend error text here. Per the API contract, any non-200
      // (unknown/revoked token, or a genuine backend error) renders the same
      // friendly "couldn't be found" state.
      if (process.env.NODE_ENV !== 'production') {
        console.error('[useSharedCourse] Failed to load shared course:', e);
      }
      setError('This shared course could not be found.');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load };
}
